import { getServerContext } from './getServerContext'
import { invariant } from './invariant'

export class UAParser {
  getResult() {
    const rawState = getServerContext().storeState
    if (!rawState) invariant('Store state is missing')
    // config lives in the redux_slice container; read it directly to avoid importing the slice.
    return (rawState as any).redux_slice?.config?.userAgentData
  }
}

export default UAParser
